import { Link } from "react-router-dom";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/events";
import { siteInfo } from "@/mocks/site";
import { formatHeat } from "@/utils/timeline";

export default function HeroSection() {
  const lead = events[0];
  const secondary = events.slice(1, 5);

  return (
    <section className="relative overflow-hidden border-b border-background-200 paper-grain">
      <div className="max-w-shell mx-auto px-4 md:px-6 pt-10 md:pt-14 pb-12 md:pb-14">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.3em] text-primary-700">
              <span className="w-8 h-px bg-primary-400" />
              独家 · 持续追踪
            </span>
            <h1 className="mt-4 font-heading text-4xl md:text-5xl font-black tracking-tight text-foreground-950">
              {siteInfo.name}
            </h1>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              {siteInfo.description}
            </p>
          </div>
          <div className="flex items-center gap-6 shrink-0">
            <div className="flex flex-col">
              <span className="font-heading text-2xl font-bold text-foreground-950">1260</span>
              <span className="text-xs text-foreground-500">在跟事件时间线</span>
            </div>
            <span className="w-px h-10 bg-background-300" />
            <div className="flex flex-col">
              <span className="font-heading text-2xl font-bold text-foreground-950">7×24</span>
              <span className="text-xs text-foreground-500">不间断更新</span>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <article className="lg:col-span-8 group">
            <Link
              to={`/events/${lead.id}`}
              className="block relative w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={lead.cover}
                alt={`${lead.title} - 头条独家爆料追踪`}
                title={`${lead.title} · 独家爆料`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulseDot" />
                  头条追踪
                </span>
                <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold leading-snug text-background-50">
                  {lead.title}
                </h2>
                <p className="mt-2 hidden sm:block text-sm leading-relaxed text-background-200/90 line-clamp-2">
                  {lead.summary}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-200/85">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    更新于 {lead.updateTime}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line" />
                    {formatHeat(lead.heat)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-list-check-2" />
                    {lead.timeline.length} 个节点
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <aside className="lg:col-span-4 flex flex-col">
            <div className="flex items-center justify-between pb-3 border-b border-background-300">
              <h2 className="font-heading text-base font-bold text-foreground-950">最新爆料</h2>
              <Link
                to="/events"
                className="text-xs text-primary-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部
              </Link>
            </div>
            <div className="flex flex-col">
              {secondary.map((ev, index) => (
                <EventCard key={ev.id} event={ev} variant="list" index={index} />
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}